// Calculation action types
export const FETCH_CALCULATIONS_REQUEST = 'calculations/FETCH_CALCULATIONS_REQUEST';
export const FETCH_CALCULATIONS_SUCCESS = 'calculations/FETCH_CALCULATIONS_SUCCESS';
export const FETCH_CALCULATIONS_FAILURE = 'calculations/FETCH_CALCULATIONS_FAILURE';

export const FETCH_CALCULATION_REQUEST = 'calculations/FETCH_CALCULATION_REQUEST';
export const FETCH_CALCULATION_SUCCESS = 'calculations/FETCH_CALCULATION_SUCCESS';
export const FETCH_CALCULATION_FAILURE = 'calculations/FETCH_CALCULATION_FAILURE';

export const CREATE_CALCULATION_REQUEST = 'calculations/CREATE_CALCULATION_REQUEST';
export const CREATE_CALCULATION_SUCCESS = 'calculations/CREATE_CALCULATION_SUCCESS';
export const CREATE_CALCULATION_FAILURE = 'calculations/CREATE_CALCULATION_FAILURE';

export const UPDATE_CALCULATION_REQUEST = 'calculations/UPDATE_CALCULATION_REQUEST';
export const UPDATE_CALCULATION_SUCCESS = 'calculations/UPDATE_CALCULATION_SUCCESS';
export const UPDATE_CALCULATION_FAILURE = 'calculations/UPDATE_CALCULATION_FAILURE';

export const DELETE_CALCULATION_REQUEST = 'calculations/DELETE_CALCULATION_REQUEST';
export const DELETE_CALCULATION_SUCCESS = 'calculations/DELETE_CALCULATION_SUCCESS';
export const DELETE_CALCULATION_FAILURE = 'calculations/DELETE_CALCULATION_FAILURE';

// Calculation Item action types
export const FETCH_CALCULATION_ITEMS_REQUEST = 'calculations/FETCH_CALCULATION_ITEMS_REQUEST';
export const FETCH_CALCULATION_ITEMS_SUCCESS = 'calculations/FETCH_CALCULATION_ITEMS_SUCCESS';
export const FETCH_CALCULATION_ITEMS_FAILURE = 'calculations/FETCH_CALCULATION_ITEMS_FAILURE';

export const CREATE_CALCULATION_ITEM_REQUEST = 'calculations/CREATE_CALCULATION_ITEM_REQUEST';
export const CREATE_CALCULATION_ITEM_SUCCESS = 'calculations/CREATE_CALCULATION_ITEM_SUCCESS';
export const CREATE_CALCULATION_ITEM_FAILURE = 'calculations/CREATE_CALCULATION_ITEM_FAILURE';

export const UPDATE_CALCULATION_ITEM_REQUEST = 'calculations/UPDATE_CALCULATION_ITEM_REQUEST';
export const UPDATE_CALCULATION_ITEM_SUCCESS = 'calculations/UPDATE_CALCULATION_ITEM_SUCCESS';
export const UPDATE_CALCULATION_ITEM_FAILURE = 'calculations/UPDATE_CALCULATION_ITEM_FAILURE';

export const DELETE_CALCULATION_ITEM_REQUEST = 'calculations/DELETE_CALCULATION_ITEM_REQUEST';
export const DELETE_CALCULATION_ITEM_SUCCESS = 'calculations/DELETE_CALCULATION_ITEM_SUCCESS';
export const DELETE_CALCULATION_ITEM_FAILURE = 'calculations/DELETE_CALCULATION_ITEM_FAILURE';

// Export/Import action types
export const EXPORT_CALCULATION_REQUEST = 'calculations/EXPORT_CALCULATION_REQUEST';
export const EXPORT_CALCULATION_SUCCESS = 'calculations/EXPORT_CALCULATION_SUCCESS';
export const EXPORT_CALCULATION_FAILURE = 'calculations/EXPORT_CALCULATION_FAILURE';

export const IMPORT_CALCULATION_REQUEST = 'calculations/IMPORT_CALCULATION_REQUEST';
export const IMPORT_CALCULATION_SUCCESS = 'calculations/IMPORT_CALCULATION_SUCCESS';
export const IMPORT_CALCULATION_FAILURE = 'calculations/IMPORT_CALCULATION_FAILURE';

export const IMPORT_CALCULATION_OLD_REQUEST = 'calculations/IMPORT_CALCULATION_OLD_REQUEST';
export const IMPORT_CALCULATION_OLD_SUCCESS = 'calculations/IMPORT_CALCULATION_OLD_SUCCESS';
export const IMPORT_CALCULATION_OLD_FAILURE = 'calculations/IMPORT_CALCULATION_OLD_FAILURE';

// UI action types
export const SELECT_CALCULATION = 'calculations/SELECT_CALCULATION';
export const CLEAR_SELECTED_CALCULATION = 'calculations/CLEAR_SELECTED_CALCULATION';
